import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import PrimaryButton from '../../../components/Buttons/PrimaryButton';
import { useToast } from '../../../hooks/toast';
import { Container, ImageArea, TextContent } from './styles';

const DataDeletion: React.FC = () => {
  const [descriptionText, setDescriptionText] = useState('');
  const { t } = useTranslation();
  const { addToast } = useToast();
  const navigate = useNavigate();

  const loadDescriptionMarkdown = useCallback(async () => {
    try {
      const response = await fetch(
        'https://fuzzyplaydev.s3.us-east-2.amazonaws.com/data-deletion-text.md',
      );

      const text = await response.text();

      setDescriptionText(text);
    } catch (error) {
      addToast({
        type: 'error',
        expression: 'Ops!',
        description: t('toasts.errors.load_description_fail'),
      });
    }
  }, [addToast, t]);

  useEffect(() => {
    loadDescriptionMarkdown();
  }, [loadDescriptionMarkdown]);

  return (
    <Container>
      <ImageArea>
        <img
          src="https://fuzzyplaydev.s3.us-east-2.amazonaws.com/logo+rt+white.svg"
          alt="fuzzy-logo"
        />
      </ImageArea>
      <TextContent>
        <ReactMarkdown
          source={descriptionText}
          plugins={[gfm]}
          className="markdown-container"
        />
      </TextContent>
      <PrimaryButton className="primary-button" onClick={() => navigate(-1)}>
        Voltar
      </PrimaryButton>
    </Container>
  );
};
export default DataDeletion;
